// when alpha is set to a value > 0,
// alpha is adding at each frame to
// full opacity
// to prevent this, see:
// https://stackoverflow.com/questions/33723384/how-to-reset-transparency-when-drawing-overlapping-content-on-html-canvas
export const GRID = {
  COLOR: 'rgba(5,36,103,0)',
  COLORZOOM: 'rgb(175,175,175)',
  SIZE: {
    X: 780,
    Y: 780,
  },
}
